module.exports = __webpack_public_path__ + "img/pic_muyulu1.5badd5cb.png";